import React, { useState } from 'react';
import { ISimpleTabs } from 'src/ui/white-labels/ocean/molecules/simple-tabs/simple-tab.types';
import { Tabs } from 'src/ui/white-labels/ocean/molecules/tabs';
import { TabContent } from 'src/ui/white-labels/ocean/molecules/tabs/tab-content';
import { TabItems } from 'src/ui/white-labels/ocean/molecules/tabs/tab-items';

export const SimpleTabs: ISimpleTabs<{ initialTabId: string }> = ({ children, initialTabId }) => {
    const [selectedTabId, setSelectedTabId] = useState(initialTabId);

    return (
        <Tabs selectedTabId={selectedTabId} handleSelectTab={setSelectedTabId}>
            {children}
        </Tabs>
    );
};

SimpleTabs.TabItems = TabItems;
SimpleTabs.Content = TabContent;